
(function () {
    'use strict';
    var controllerId = 'tasklistCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$http', '$location', 'NgTableParams', tasklistCtrl]);

    function tasklistCtrl(common, datacontext, $scope, $http, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.tasks = [];
        vm.title = 'Task List View';
        vm.startSearch = 1;
        vm.query = {
                order_by:"st.run_status asc,run_on",
                order_dir:"",
                title:"",
                page:1,
                limit:50
            };

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	console.log(vm.query);
            for ( var i in newValue ) {

                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    console.log(oldValue[i]);
                    if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true || oldValue[i] < 0 ){

                    	get_scheduled_tasks();

                    }else{
                        return "";
                    }

                }
            }

        });

        activate();

        function activate() {
            var promises = [get_scheduled_tasks()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        function get_scheduled_tasks() {
            vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            },{

                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_scheduled_tasks(vm.query).then(function (httpResult) {
                    	params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;

                    	vm.system_live = httpResult.data.SYSTEM_LIVE;

                        vm.tasks = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }
        $scope.stopTasks = function(isValid) {
            $scope.submitted = 1;
        	 $scope.submitted = 0;
        	 $scope.stopTasks.disabled=true;
        	 $scope.stopTasks.button_diable =1;
            // stop scheduled tasks
            datacontext.stopTasks({startElement:0}).then(function (httpResult) {
            	vm.system_live = 0;
            });

        };

        $scope.startTasks = function(isValid) {
            $scope.submitted = 1;
	    	 $scope.submitted = 0;
	    	 $scope.startTasks.disabled=true;
	    	 $scope.startTasks.button_diable =1;
	            // Create Vendor Product
	            datacontext.stopTasks({startElement:1}).then(function (httpResult) {
	            	vm.system_live = 1;
	            });

        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'inValidAddressCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', inValidAddressCtrl]);

    function inValidAddressCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        activate();

        function activate() {
            var promises = [getInvalidAddressReport()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        function getInvalidAddressReport() {
            return datacontext.getInvalidAddressReport().then(function (httpResult) {
                vm.data = httpResult.data.data;
            });
        }
    }
})();



(function () {
    'use strict';
    var controllerId = 'reviewPhantomsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$filter', '$http', '$location','ngTableParams', reviewPhantomsCtrl]);

    function reviewPhantomsCtrl(common, datacontext, $scope, $filter, $http, $location, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.tasks = [];
        vm.title = 'Task List View';

        vm.query = {
            search:'',
            page:1,
            limit:2000
        };

        activate();

        function activate() {
            var promises = [getProducts()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        function getProducts() {
            return datacontext.qPhantomReview().then(function (httpResult) {
                var data = httpResult.data.data;

                $scope.tableParams = new ngTableParams({
                    page: 1,            // show first page
                    count: 2000,          // count per page
                    sorting: {
                        amz_proj_unit_sales: 'desc'     // initial sorting
                    }
                }, {
                    total: data.length, // length of data
                    getData: function($defer, params) {
                        // use build-in angular filter
                        var orderedData = params.sorting() ?
                            $filter('orderBy')(data, params.orderBy()) :
                            data;

                        $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                    }
                });
            });
        }
    }


})();

(function () {
    'use strict';
    var controllerId = 'rePriceExportCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', rePriceExportCtrl]);

    function rePriceExportCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.tasks = [];
        vm.title = 'repricer_export';

        function repricer_export() {
            return datacontext.repricer_export().then(function (httpResult) {
                vm.tasks = httpResult.data.data;
            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'amazonErrorsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', amazonErrorsCtrl]);

    function amazonErrorsCtrl(common, datacontext, $scope, $modal) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.tasks = [];

        activate();

        function activate() {
            var promises = [get_amazon_errors()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        function get_amazon_errors() {
            return datacontext.get_amazon_errors().then(function (httpResult) {
                vm.errors = httpResult.data.data;
            });
        }

        $scope.view_s3_modal = function (file) {

            switch(file.action_id) {
                case 1:
                    // Get Flat File orders
                    file.location = "/mws/orders/" + file.data_id + ".txt";
                    break;
                case 2:
                    file.location = "/mws/fulfillment/" + file.data_id + ".txt";
                    break;
                case 3:
                    file.location = "/mws/products/" + file.data_id + ".txt";
                    break;
                case 4:
                    file.location = "/mws/inventory/" + file.data_id + ".txt";
                    break;
                case 9:
                    file.location = "/mws/orders/" + file.data_id + ".txt";
                    break;
                default:
                    file.location = "0";
            }

            var modalInstance = $modal.open({
                templateUrl: '/app/reports/partials/read_s3_modal.html',
                controller: 'getS3ModalCtrl',
                resolve: {
                    file: function () {
                        return file;
                    }
                }
            }).result.then(function(result){
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'getS3ModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','file', getS3ModalCtrl]);

    function getS3ModalCtrl(common, datacontext, $scope, $modalInstance, file) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.location = file.location;
        $scope.action_id = file.action_id;
        $scope.feed_submission_id = file.feed_submission_id;


        // Ship Methods
        datacontext.s3readFile(file.location).then(function(response) {
            $scope.data_raw = response.data.data;
        });

        $scope.ok = function () {
            // set variables
            var formData = {};
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'getS3FileCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', getS3FileCtrl]);

    function getS3FileCtrl(common, datacontext, $scope ) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.file = {
            location:"/mws/orders/",
            data_id:""
        };

        $scope.read_s3_file = function () {
            datacontext.s3readFile($scope.file.location + $scope.file.data_id + '.txt').then(function(response) {

                    $scope.data_raw = response.data.data;

            });
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'viewS3Ctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$http', '$routeParams', viewS3Ctrl]);

    function viewS3Ctrl(common, datacontext, $scope, $http, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.type = $routeParams.type;
        $scope.data_id = $routeParams.data_id;
        $scope.location = '/' + $scope.type + '/' + $scope.data_id + '.txt';

        // Ship Methods
        datacontext.s3readFile(file_location).then(function(response) {
        });

    }
})();

(function() {
    'use strict';
    var controllerId = 'getSaleReportCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', getSaleReportCtrl]);

    function getSaleReportCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        activate();

        function activate() {
            var promises = [get_sales_report()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated PO List View');
                });
        }

        function get_sales_report() {
            return datacontext.get_sales_report().then(function (httpResult) {
                $scope.total_orders = '[' + httpResult.data.data.total_orders + ']';

                $scope.options = {
                    chart: {
                        type: 'historicalBarChart',
                        height: 450,
                        margin : {
                            top: 20,
                            right: 20,
                            bottom: 60,
                            left: 50
                        },
                        x: function(d){return d[0];},
                        y: function(d){return d[1]/100000;},
                        showValues: true,
                        valueFormat: function(d){
                            return d3.format(',.1f')(d);
                        },
                        transitionDuration: 500,
                        xAxis: {
                            axisLabel: 'X Axis',
                            tickFormat: function(d) {
                                return d3.time.format('%x')(new Date(d))
                            },
                            rotateLabels: 50,
                            showMaxMin: false
                        },
                        yAxis: {
                            axisLabel: 'Y Axis',
                            axisLabelDistance: 35,
                            tickFormat: function(d){
                                return d3.format(',.1f')(d);
                            }
                        }
                    }
                };

                $scope.data = [
                    {
                        "key" : "Sales" ,
                        "bar": true,
                        "values" : [[1404056160,2]]
                    }
                ];
            });
        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'getSalesVelocityCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$window', '$modal','$filter', 'ngTableParams', getSalesVelocityCtrl]);

    function getSalesVelocityCtrl(common, datacontext, $scope, $window, $modal, $filter, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.products = [];
        vm.totalPages = 0;
        vm.productCount = 0;
        vm.currentPage = 1;

        //default criteria that will be sent to the server
        $scope.filterCriteria = {
            hasCat: '',
            manufacturer: '',
            is_orderable: '',
            on_order: '',
            vendor:''
        };

        $scope.exportCSV = function () {
            datacontext.get_sales_velocity().then(function(httpResult) {
                var data = httpResult.data.data;
                // filtering
                data = params.filter() ?
                    $filter('filter')(data, params.filter()) :
                    data;
                params.total(data.length);
                $defer.resolve(data.slice((params.page() - 1) * params.count(), params.page() * params.count()));
            });
        };

        activate();

        function activate() {
            var promises = [
                get_sales_velocity(),
                get_product_categories(),
                get_manufacturers(),
                get_vendors()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Pack List View');
                });
        }

        function get_product_categories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;

            });
        }

        function get_manufacturers() {
            return datacontext.get_manufacturers().then(function (httpResult) {
                $scope.manufacturers = httpResult.data;
            });
        }

        function get_vendors() {
            return datacontext.get_vendors().then(function (httpResult) {
                $scope.vendors = httpResult.data.data;
            });
        }

        function get_sales_velocity() {
            return datacontext.get_sales_velocity().then(function (httpResult) {
                vm.products = httpResult.data.data;
            });
        }

        $scope.open_on_order_product_modal = function (vpid) {

            $scope.on_order_product = {vendor_product_id:vpid};

            var modalInstance = $modal.open({
                templateUrl: '/app/purchaseorderproducts/partials/on_order_product_modal.html',
                controller: 'onOrderProductModalCtrl',
                resolve: {
                    on_order_product: function () {
                        return $scope.on_order_product;
                    }
                }
            }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'SalesReportCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$filter', '$cookies', 'NgTableParams', SalesReportCtrl]);

    function SalesReportCtrl(common, datacontext, $scope, $filter, $cookies, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.customDate = 0;
        vm.user_role_id = $cookies.get('user_role_id');
        console.log("vm.user_role_id"+vm.user_role_id);
        console.log(['1','2','3'].indexOf(vm.user_role_id));
        // get first day of last month
        // moment(moment().subtract( 1,'months').startOf('month').format('YYYY-MM-DD')).toDate(),
        // moment(moment().subtract( 1,'months').endOf('month').format('YYYY-MM-DD')).toDate(),
        vm.query = {
            start_date: moment(moment().subtract( 30,'day').format('YYYY-MM-DD')).toDate(),
            end_date:   moment(moment().format('YYYY-MM-DD')).toDate(),
            store_id: "",
            is_pod:"",
            fulfillment_warehouse_id: "",
            page:1,
            order_by:'ordered_on',
            order_dir: 'desc',
            vendor_id:'',
            vendor_stock_status_id:'',
            week_no:'0',
            month_no:'0',
            filter_type: '1',
            category_id:'',
            count: 50,
            limit: 50
        };

        vm.cStartDate = vm.query.start_date;
        vm.cEndDate = vm.query.end_date;
        vm.page = 1;

        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        $scope.getNumber = function(num) {
            return new Array(num);
        }

        $scope.newValue = function(filter_type){
            vm.filter_type_value = filter_type;
        }

        /*$scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
                if ( i !== 'page' && i !== 'limit' && i !== 'count' && newValue[i] !== oldValue[i]) {
                     console.log(i, newValue[i], oldValue[i]);

                     if((i === 'filter_type')){
                        console.log("logging",newValue[i]);
                        var cur_date = new Date();

                        if(newValue[i] == 2){
                          vm.query.limit = 10;
                          vm.query.count = 60;
                          vm.customDate = 1;
                        }else if(newValue[i] == 3){
                          vm.query.limit = 12;
                          vm.query.count = 30;
                          vm.customDate = 1;
                        }else{
                          vm.query.limit = 31;
                          vm.query.count = 50;
                        }

                     }

                    get_sales_report();
                }

            }
        });*/

        if(['1','2','3'].indexOf(vm.user_role_id) > -1){
          activate();
        }
        function activate() {
            var promises = [
                get_sales_report(),
                get_stores(),
                get_fulfillment_warehouses(),
                getProductCategories(),
                getProductSource(),
		            get_vendors(),
                get_vendor_stock_status(),
                get_shipping_regions(),
                get_content_themes_list()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //log('Activated');
                });
        }
        function get_content_themes_list() {
            return datacontext.get_content_themes_list().then(function (httpResult) {
                vm.content_themes = httpResult.data;
            });
        }
        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function get_fulfillment_warehouses() {
            return datacontext.get_warehouses().then(function (httpResult) {
                vm.warehouses = httpResult.data.data;
            });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
            });
        }
        function getProductSource() {
            return datacontext.get_product_source().then(function (httpResult) {
                vm.product_source = httpResult.data.data;
            });
        }

        function get_vendors() {
            return datacontext.get_vendors_v1().then(function(httpResult) {
                $scope.vendors = httpResult.data.data;
            });
        }
        function get_vendor_stock_status() {
            datacontext.get_vendor_stock_status().then(function (httpResult) {
                $scope.vendor_stock_status = httpResult.data.data;
            });
        }
        function get_shipping_regions() {
            return datacontext.get_shipping_regions().then(function (httpResult) {
                vm.shipping_regions = httpResult.data.data;
            });
        }

        function get_sales_report() {

            console.log("calling");
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {
                    // set page
                    vm.query.page = params.page;

                    console.log("calling 12");

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    vm.sales = [];
                    vm.totals = [];
                    vm.salesDates = [];

                    log_success("Loading !!!");
                    return datacontext.get_sales_report(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        var data = httpResult.data;
                        // update table params
                        console.log("httpResult",httpResult);
                        console.log("data.total",data.COUNT);
                        params.total(data.COUNT);
                        $scope.resultcount = data.COUNT;
                        $scope.ORDERSNUM = httpResult.data.ORDERSNUM;
                        $scope.last_ran = httpResult.data.LAST_RAN;

                        vm.cStartDate = new Date(data.START_DATE);
                        vm.cEndDate = new Date(data.END_DATE);
                        vm.page = data.PAGE;

                        // set new data
                        vm.sales = data.data;
                        var labels = [];
                        var orders_num = [];


                        $scope.ageData = [];
                        var cnt = 0;
                        var ween_num_v1 = 0;
                        var week_num = "";
                        var mon_num_v1 = 0;
                        var mon_num = "";
                        for ( var i in vm.sales ) {
                          if(angular.isDefined(vm.sales[i].ordered_on)){
                            labels.unshift(vm.sales[i].ordered_on.toString() + '');
                          }else if(angular.isDefined(vm.sales[i].week)){
                            ween_num_v1 = ( (vm.page - 1)*30 + (cnt + 1));
                            week_num = 'week '+ween_num_v1;
                            labels.unshift(week_num.toString() + '');
                            console.log(week_num);
                          }else if(angular.isDefined(vm.sales[i].mon)){
                            mon_num_v1 =((vm.page - 1)*24 + (cnt + 1) )
                            mon_num = 'month '+mon_num_v1;
                            labels.unshift(mon_num.toString() + '');
                            console.log(mon_num);
                            //labels.unshift(vm.sales[i].mon.toString() + '');
                          }

                          orders_num.unshift(vm.sales[i].total_sales);
                          cnt = cnt+1;
                        }
                        $scope.series = ["total_sales"];
                        $scope.ageLabels = labels;
                        $scope.ageData.unshift(orders_num);

                        console.log("ft",vm.query.filter_type);
                        if(vm.query.filter_type > 1){
                            vm.salesDates = data.DATA1;
                            console.log("in1",vm.salesDates);
                        }
                        vm.totals = data.totals[0];

                        log_success("Loaded !!!");
                        //$defer.resolve(data.data);
                    });

                }
            });
        }

        $scope.get_sales_report_data = function(store_id,shipping_region_id,fulfillment_warehouse_id,content_theme_id,vendor_id,vendor_stock_status_id,territory,category_id,product_source_id,filter_type,start_date,end_date){
            console.log('sales data..');

            vm.query = {
                store_id: store_id,
                shipping_region_id: shipping_region_id,
                fulfillment_warehouse_id: fulfillment_warehouse_id,
                content_theme_id: content_theme_id,
                vendor_id: vendor_id,
                vendor_stock_status_id: vendor_stock_status_id,
                territory: territory,
                category_id: category_id,
                product_source_id: product_source_id,
                filter_type: filter_type,
                start_date: start_date,
                end_date: end_date,
                is_pod: '',
                page: 1,
                order_by: 'ordered_on',
                order_dir: 'desc',
                week_no: '0',
                month_no: '0',
                count: 50,
                limit: 50

            }

            get_sales_report();

            //console.log(vm.query);
        }

    }
})();



(function() {
    'use strict';
    var controllerId = 'reportorderfulfillmentCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$window', '$modal', '$filter', 'ngTableParams', reportorderfulfillmentCtrl]);

    function reportorderfulfillmentCtrl(common, datacontext, $scope, $window, $modal, $filter, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.query = {
          store_id:"",
            fulfillment_warehouse_id:""

        };

        activate();

        function activate() {
            var promises = [get_sales_report()];
            common.activateController(promises, controllerId)
                .then(function() {
                    log('Activated');
                });
        }

        function get_sales_report() {
            return datacontext.get_sales_report(vm.query).then(function(httpResult) {
                vm.data = httpResult.data.data;

                $scope.tableParams = new ngTableParams({
                    page: 1,            // show first page
                    count: 50,          // count per page
                    sorting: {
                        name: 'asc'     // initial sorting
                    },
                    filter: vm.query
                }, {
                    total: 0,           // length of data
                    getData: function($defer, params) {
                        // ajax request to api
                        Api.get(params.url(), function(data) {
                            $timeout(function() {
                                // update table params
                                params.total(data.total);
                                // set new data
                                $defer.resolve(data.result);
                            }, 500);
                        });
                    }
                });

            });
        };


        $scope.open_orders_modal = function (date) {

            $scope.open_orders =
            {
                date:date
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/open_orders_modal.html',
                controller: 'openordersCtrl',
                resolve: {
                    open_orders: function () {
                        return $scope.open_orders;
                    }
                }
            }).result.then(function(result){

                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'amazonRepriceCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$location', '$filter', 'NgTableParams', amazonRepriceCtrl]);

    function amazonRepriceCtrl(common, datacontext, $scope, $location, $filter, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.orders = [];
        vm.title = 'Amazon Reprice Report';

        //default criteria that will be sent to the server
        vm.query = {
          store_id:"8",
          search:'',
          queryType:'array-count',
          order_by:'store_product_id',
          order_dir:'desc',
          page:1,
          limit:20
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    // console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    get_amazon_reprice_report();
                }
            }
            if ( url_used ) {
                //console.log(vm.query);
                // $location.update(vm.query)
            }
        });

        activate();

        function activate() {
            var promises = [get_amazon_reprice_report()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Order List View');
                });
        }


        function get_amazon_reprice_report() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_amazon_reprice_report(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();


(function() {
    'use strict';
    var controllerId = 'walmartRepriceCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$location', '$filter', 'NgTableParams', walmartRepriceCtrl]);

    function walmartRepriceCtrl(common, datacontext, $scope, $location, $filter, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.orders = [];
        vm.title = 'Walmart Reprice Report';

        //default criteria that will be sent to the server
        vm.query = {
          store_id:"8",
          queryType:'array-count',
          order_by:'store_product_id',
          order_dir:'desc',
          page:1,
          limit:20
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    // console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    get_walmart_reprice_report();
                }
            }
            if ( url_used ) {
                //console.log(vm.query);
                // $location.update(vm.query)
            }
        });

        activate();

        function activate() {
            var promises = [get_walmart_reprice_report()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Order List View');
                });
        }


        function get_walmart_reprice_report() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_walmart_reprice_report(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();


(function() {
    'use strict';
    var controllerId = 'openordersCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$filter', '$modalInstance','open_orders', openordersCtrl]);

    function openordersCtrl(common, datacontext, $scope, $filter, $modalInstance, open_orders) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.filter = {
            date_ordered_on :  $filter('date')(open_orders.date, 'shortDate'),
            order_status_id : '1,4'
        };

       datacontext.get_orders($scope.filter).then(function (httpResult) {
            $scope.orders = httpResult.data.data;
        });

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'qualityControlCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$location', '$filter', 'NgTableParams', qualityControlCtrl]);

    function qualityControlCtrl(common, datacontext, $scope,$location, $filter, NgTableParams) {
        var vm = this;
        vm.query_25 = {
                queryType:'count',
                search:'',
                has_parent:'',
                store_product_status_id:'',
                store_id:'99',
                warehouse_id:'4',
                description_status_id:'',
                category_id:'',
                order_by:'store_product_id',
                order_dir:'desc',
                fit_to_sell:'',
                is_active_override:'1',
                missingMinMax:'',
                synd_inv_error:'',
                synd_sync_timeout:'',
                is_oversize:'',
                marketplace_in_stock:'1',
                synd_sync_fail:'',
                scrape_status_id:'',
                is_current_min_max_locked:'',
                is_current_price_rule_locked:'',
                current_price_rule_id:'',
                reprice_reason_id:'',
                last_on_hand:'',
                mp_last_inventory:'0',
                search_category:1,
                sort_by:'',
                page:1,
                limit:20
            };
        vm.query_13 = {
                queryType:'count',
                search:'',
                has_parent:'',
                is_print_on_demand: '0',
                store_product_status_id:'1',
                store_id:'99',
                warehouse_id:'4',
                description_status_id:'',
                category_id:'',
                order_by:'store_product_id',
                order_dir:'desc',
                fit_to_sell:'',
                is_active_override:'1',
                missingMinMax:'',
                synd_inv_error:'',
                synd_sync_timeout:'',
                is_oversize:'',
                marketplace_in_stock:'0',
                synd_sync_fail:'',
                scrape_status_id:'',
                is_current_min_max_locked:'',
                is_current_price_rule_locked:'',
                current_price_rule_id:'',
                reprice_reason_id:'',
                last_on_hand:'',
                mp_last_inventory:'1',
                search_category:1,
                sort_by:'',
                page:1,
                limit:20
            };
        get_store_products_sp_list_25();
        get_store_products_sp_list_13();
        function get_store_products_sp_list_25() {
        	// ajax request to api
            datacontext.get_store_products_sp_list(vm.query_25).then(function (httpResult) {
                vm.results_total_25 = httpResult.data.total;
            });
        }
        function get_store_products_sp_list_13() {
            // ajax request to api
            datacontext.get_store_products_sp_list(vm.query_13).then(function (httpResult) {
                vm.results_total_13 = httpResult.data.total;
            });
        }

    }
})();

(function() {
    'use strict';
    var controllerId = 'onOrderProductModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','on_order_product', onOrderProductModalCtrl]);

    function onOrderProductModalCtrl(common, datacontext, $scope, $modalInstance, on_order_product) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.vendor_product_id = on_order_product.vendor_product_id;

        datacontext.get_vendor_product_po_history({vendor_product_id:$scope.vendor_product_id}).then(function (httpResult) {
            $scope.product_po_log = httpResult.data.data;
        });



        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'ordersNoTrackingCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$location', '$filter', 'NgTableParams', ordersNoTrackingCtrl]);

    function ordersNoTrackingCtrl(common, datacontext, $scope, $location, $filter, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.orders = [];
        vm.title = 'Order List View';

        //default criteria that will be sent to the server
        vm.query = {
            queryType:'array-count',
            search: "",
            store_id: "",
            financial_status_id: "4",
            fulfillment_status_id: "",
            cancel_reason_id: "",
            order_status_id: "",
            warehouse_id: 4,
            order_age: "3",
            has_tracking_code:0,
            order_by: "order_id",
            order_dir: "desc",
            page: 1,
            limit: 20
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    // console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    get_orders();
                }
            }
            if ( url_used ) {
                //console.log(vm.query);
                // $location.update(vm.query)
            }
        });

        activate();

        function activate() {
            var promises = [get_orders_no_tracking()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Order List View');
                });
        }


        function get_orders_no_tracking() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_order_packages(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();



(function() {
    'use strict';
    var controllerId = 'specialHandlingReportCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$window', '$filter', 'ngTableParams', specialHandlingReportCtrl]);

    function specialHandlingReportCtrl(common, datacontext, $scope, $window, $filter, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.orders = [];
        vm.title = 'Order List View';

        vm.totalPages = 0;
        vm.orderCount = 0;
        vm.currentPage = 1;

        //default criteria that will be sent to the server
        vm.filterCriteria = {
            pageNumber: 1,
            sortDir: 'desc',
            sortedBy: 'ordered_on'
        };

        vm.customFilter = function(queryColumn, query){
            if(queryColumn==='')
            {
                return "''";
            }else{
                return {queryColumn:query};
            }
        };

        activate();

        function activate() {
            var promises = [get_orders_manual_shipmethod()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Order List View');
                });
        }

        function get_orders_manual_shipmethod() {
            return datacontext.get_orders_manual_shipmethod(vm.filterCriteria).then(function(httpResult) {
                var orders = httpResult.data.data;

                $scope.$watch("filter.$", function () {
                    $scope.tableParams.reload();
                    $scope.tableParams.$params.page = 1;
                });

                $scope.$watch("order_status.$", function () {
                    $scope.tableParams.reload();
                    $scope.tableParams.$params.page = 1;
                });

                $scope.$watch("fulfillment_status.$", function () {
                    $scope.tableParams.reload();
                    $scope.tableParams.$params.page = 1;
                });

                $scope.$watch("payment_status.$", function () {
                    $scope.tableParams.reload();
                    $scope.tableParams.$params.page = 1;
                });

                $scope.tableParams = new ngTableParams({
                    page: 1,            // show first page
                    count: 100,           // count per page
                    sorting: {
                        order_id: 'asc'     // initial sorting
                    },
                    filter: {

                    }
                }, {
                    total: orders.length, // length of data
                    getData: function($defer, params) {

                        var QueryData = $filter('filter')(orders, $scope.filter);
                        var order_status = $filter('filter')(QueryData, $scope.order_status);
                        var fulfillment_status = $filter('filter')(order_status, $scope.fulfillment_status);
                        var payment_status = $filter('filter')(fulfillment_status, $scope.payment_status);

                        var filteredData = params.filter() ?
                            $filter('filter')(payment_status, params.filter()) :
                            data;
                        var orderedData = params.sorting() ?
                            $filter('orderBy')(filteredData, params.orderBy()):
                            filteredData;

                        params.total(orderedData.length); // set total for recalc pagination
                        $scope.resultcount = orderedData.length;
                        $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                    },
                    $scope: $scope
                });
            });
        }
    }
})();


(function() {
    'use strict';
    var controllerId = 'productSalesCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$routeParams', '$window', '$filter', '$location', 'NgTableParams', productSalesCtrl]);

    function productSalesCtrl(common, datacontext, $scope, $routeParams, $window, $filter, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.sales_history = [];
        vm.title = 'Order List View';

        vm.query = {
            queryType:'array-count',
            product_id:$routeParams.pid,
            order_by:'order_id',
            order_dir:'desc',
            page:1,
            limit:20
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // setting for audit log
        $scope.audit_link_id = $routeParams.pid;
        $scope.audit_type_id = 3;
        $scope.audit_sub_type_id = 3;

        activate();

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    get_product_sale_history();
                }
            }
        });

        //activate();

        function activate() {
            var promises = [get_product_sale_history()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }

        function get_product_sale_history() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_product_sale_history(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();

(function() {
    'use strict';
    var controllerId = 'asinImportErrorsCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$routeParams', '$window', '$filter', '$location', 'ngTableParams', productSalesCtrl]);

    function productSalesCtrl(common, datacontext, $scope, $routeParams, $window, $filter, $location, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.asin_import_errors = [];

        activate();

        function activate() {
            var promises = [get_asin_import_errors()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated ASIN List View');
                });
        }

        function get_asin_import_errors() {
            return datacontext.get_asin_import_errors().then(function(httpResult) {
                var data = httpResult.data.data;

                $scope.tableParams = new ngTableParams(
                    // merge default params with url
                    angular.extend({
                            page: 1,            // show first page
                            count: 20,          // count per page
                            sorting: {
                                created_on: 'asc'     // initial sorting
                            }
                        },
                        $location.search()), {
                        total: data.length, // length of data
                        getData: function($defer, params) {
                            $location.search(params.url()); // put params in url

                            // use build-in angular filter
                            var orderedData = params.sorting ?
                                $filter('orderBy')(data, params.orderBy()) :
                                data;

                            $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                        }
                    }
                );

            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'storeProductsRepricerCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location','NgTableParams', storeProductsRepricerCtrl]);
    function storeProductsRepricerCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Product List View';
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            store_product_status_id:'1',
            amz_buybox_status_id:'5',
            store_id:'1',
            warehouse_id:'',
            description_status_id:'',
            category_id:'',
            fit_to_sell:'',
            is_active_override:'1',
            missingMinMax:'',
            synd_inv_error:'',
            synd_sync_timeout:'',
            is_oversize:'',
            marketplace_in_stock:'1',
            synd_sync_fail:'',
            scrape_status_id:'',
            is_current_min_max_locked:'',
            is_current_price_rule_locked:'',
            current_price_rule_id:'',
            reprice_reason_id:'',
            have_lowest_price:'',
            price_push_check:'',
            has_competitors:'',
            product_source_id:'',
            current_price_cmp:'',
            in_stock:'',
            order_by:'sp.price_sync_on',
            order_dir:'ASC',
            page:1,
            limit:20
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	/*if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_store_products();
                }
            }
            vm.grid = 0;*/

            for ( var i in newValue ) {

                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                	vm.startSearch ++;
                	if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true ){

                		vm.grid = 0;
                		get_store_products();
                	}
                }
            }
            vm.grid = 0;

        });

        activate();

        function activate() {
            var promises = [
                get_store_products(),
                get_store_product_status(),
                get_store_product_scrape_status(),
                getProductCategories(),
                get_stores(),
                get_warehouses(),
                get_price_rules(),
                getProductStatus(),
                get_reprice_reason(),
                get_amz_buybox_status(),
                get_min_max_rules(),
                getProductSource()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }


        function get_min_max_rules() {
            return datacontext.get_min_max_rules().then(function (httpResult) {
                $scope.min_max_logic = httpResult.data.data;
            });
        }
        function getProductSource() {
            return datacontext.get_product_source().then(function (httpResult) {
                vm.product_source = httpResult.data.data;
            });
        }
        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
            });
        }

        function get_store_product_status() {
            return datacontext.get_store_product_status().then(function(httpResult) {
                $scope.store_product_status = httpResult.data.data;
            });
        }

        function get_amz_buybox_status() {
            return datacontext.get_amz_buybox_status().then(function(httpResult) {
                $scope.amz_buybox_status = httpResult.data.data;
            });
        }

        function get_store_product_scrape_status() {
            return datacontext.get_store_product_scrape_status().then(function(httpResult) {
                vm.store_product_scrape_status = httpResult.data.data;
            });
        }

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function getProductStatus() {
            return datacontext.get_product_status().then(function (httpResult) {
                vm.product_status = httpResult.data.data;
            });
        }

        function get_warehouses() {
            return datacontext.get_warehouses().then(function(httpResult) {
                $scope.warehouses = httpResult.data.data;
            });
        }

        function get_price_rules() {
            return datacontext.get_price_rules().then(function(httpResult) {
                $scope.price_rules = httpResult.data.data;
            });
        }

        function get_reprice_reason() {
            return datacontext.get_reprice_reason().then(function(httpResult) {
                vm.reprice_reasons = httpResult.data.data;
            });
        }

        function get_store_products() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_store_products(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();
